import { useSnackbar } from 'notistack';
import { useMutation } from 'react-query';

import { axios } from 'lib';

const updateCompanyCompetenceAreas = ({ companyID, competenceAreaIDs }) =>
  axios.put(
    `/api/companies/${companyID}/competence_areas`,
    JSON.stringify({
      competence_area_ids: competenceAreaIDs,
    })
  );

export const useUpdateCompanyCompetenceAreas = () => {
  const { enqueueSnackbar } = useSnackbar();

  return useMutation({
    mutationFn: updateCompanyCompetenceAreas,
    onError: (error) => {
      enqueueSnackbar(error?.message || 'Some error occured', { variant: 'error' });
    },
  });
};
